import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CalendarComponent } from './calendar.component';
import { ComplianceTasksComponent } from './compliance-tasks/compliance-tasks.component';
import { AuthGuard } from '../auth.guard';

const routes: Routes = [
  {
    path: 'calendars',
    component: CalendarComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'compliance-tasks',
    component: ComplianceTasksComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CalendarRoutingModule { }
